import { render, staticRenderFns } from "./SchematicViewHeader.vue?vue&type=template&id=24987330&"
import script from "./SchematicViewHeader.vue?vue&type=script&lang=ts&"
export * from "./SchematicViewHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports